/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Create a function that will store calls to it in a queue until
 * the queue is flushed.
 *
 * Usage:
 * ```
 * const [track, flushTrackQueue] = makeQueuable(() => console.log('do something'));
 * track(); // no log
 * track(); // no log
 * flushTrackQueue(); // 'do something' logged twice
 * ```
 */
export const makeQueueable = <T extends (..._args: any[]) => any>(
  fn: T,
): [(...args: Parameters<T>) => void, () => void] => {
  let queue: Array<Parameters<T>> = [];
  let initialized = false;
  const queueable = (...args: Parameters<T>) => {
    if (!initialized) {
      queue.push(args);
      return;
    }
    fn(...args);
  };
  const flushQueue = () => {
    if (initialized) {
      return;
    }
    queue.forEach(async (args) => {
      await fn(...args);
    });
    queue = [];
    initialized = true;
  };

  return [queueable, flushQueue];
};
